import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaLeaf } from "react-icons/fa"; // Eco-friendly icon
import styles from "./LoadingScreen.module.css";

const ecoFacts = [
    { title: "🌱 Save Trees & Forests", subtitle: "1 tree can produce about 8,000 A4 sheets of paper. Go digital to save forests!" },
    { title: "💧 Save Water & Energy", subtitle: "Producing one ton of paper requires 26,500 liters of water! Digital invoices use ZERO water." },
    { title: "🌍 Reduce Carbon Footprint", subtitle: "Paper production contributes to nearly 10% of deforestation worldwide. E-invoices help reduce this impact." },
    { title: "♻️ Less Waste, More Sustainability", subtitle: "93% of paper receipts end up in the trash within minutes. Digital receipts last forever without clutter!" },
    { title: "🌳 Be Kind to Nature", subtitle: "Every year, over 15 billion trees are cut down, and a huge portion is used for paper production. Switch to digital!" },
    { title: "⚡ Energy Conservation", subtitle: "The paper industry is the 5th largest energy consumer worldwide. Going digital helps reduce energy waste." },
    { title: "🚀 Small Change, Big Impact", subtitle: "If just 1% of businesses switched to digital invoices, we could save millions of trees and tons of CO₂ every year!" }
];

const getRandomFact = () => ecoFacts[Math.floor(Math.random() * ecoFacts.length)];

const LoadingScreen = () => {
    const [currentFact, setCurrentFact] = useState(getRandomFact());

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentFact(getRandomFact());
        }, 5000); // Change fact every 5 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    return (
        <div className={styles.loadingWrapper}>
            <motion.p
                className={styles.loadingText}
                animate={{ opacity: [0, 1, 0] }}
                transition={{ duration: 5, repeat: Infinity }}
            >
                <FaLeaf color="green" /> Loading Invoice...
            </motion.p>
            <motion.div
                key={currentFact.title}
                className={styles.factContainer}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 1.05 }}
                transition={{ duration: 0.5 }}
            >
                <h3 className={styles.factTitle}>{currentFact.title}</h3>
                <p className={styles.factSubtitle}>{currentFact.subtitle}</p>
            </motion.div>

        </div>
    );
};

export default LoadingScreen;
